const displayValues = [
    'none',
    'inline',
    'inline-block',
    'block',
    'contents'
];
export { displayValues };

//# sourceMappingURL=box.prop.js.map